<template>
    <div>
        <!-- <vx-card> -->
            <!-- Filter -->
            <!-- <div class="flex mb-4 justify-end">
                <div class="w-1/4 bg-grid-color-secondary h-12">
                    <vs-input
                        icon-pack="feather"
                        icon="icon-search"
                        v-model="search"
                        class="w-auto mr-1"
                    />
                </div>
                <div class="w-1/4 bg-grid-color h-12">
                    <v-select
                        taggable
                        class="w-full mr-1"
                        label="office_name"
                        index="id"
                        :options="all_offices"
                        v-model="office_id"
                        placeholder="Select Office"
                    ></v-select>
                </div>
                <div class="w-1/4 bg-grid-color-secondary h-12" v-if="office_id && office_id != 'all'">
                    <v-select
                        taggable
                        multiple
                        class="w-full"
                        label="department_name"
                        index="id"
                        :options="all_departments"
                        v-model="department_id"
                    ></v-select>
                </div>
            </div> -->
            <!-- <vs-tabs v-model="sub_tab" alignment="center" class="all-tabs set_min_height">
                <vs-tab label="Day">
                    <daily-activity :search="search" :office_id="office_id" :department_id="department_id"></daily-activity>
                </vs-tab>
                <vs-tab label="Week">
                    <weekly-activity :search="search" :office_id="office_id" :department_id="department_id"></weekly-activity>
                </vs-tab>
            </vs-tabs>
        </vx-card> -->
         <!-- <timesheet-detail></timesheet-detail> -->
          <vx-card class="new-card-common">
                <div class="all-tabs mb-0">
                  <div class="con-ul-tabs">
                    <div class="common-tabs">
                      <div class="one">
                        <div class="datepicker-main">
                        
                            <!-- Datepicker for day timesheet -->
                            <div class="dis-flex align-items-center" v-show="timesheet_type == 'day'">
                              <label for class="float-right w-auto mr-2 pb-0">Date</label>
                              <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                    placeholder="Select Date"
                                    class="float-right calendar-icon-right top-45"
                                    :format="format"
                                    v-model="day_current_date"
                                    :disabledDates="disabledDates"
                              ></datepicker>
                            </div>
                            <!-- Datepicker for week timesheet -->
                            <div class="dis-flex align-items-center" v-show="timesheet_type == 'week'">
                              <label for class="float-right w-auto mr-2 pb-0">Week Date</label>
                              <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                    placeholder="Select Week Date"
                                    class="float-right calendar-icon-right top-45"
                                    :format="format"
                                    v-model="week_current_date"
                                    :disabledDates="disabledDates"
                              ></datepicker>
                            </div>
                        
                        </div>
                      </div>
                      <div class="two">
                        <span class="" v-bind:class="{'active':(timesheet_type == 'day')}" @click.prevent="timesheet_type = 'day'">Day</span>
                        <span class="" v-bind:class="{'active':(timesheet_type == 'week')}" @click.prevent="timesheet_type = 'week'">Week</span>
                      </div>
                      <div class="three" v-show="showCSVPDFButtons">
                        <vue-json-to-csv :json-data="getCsvDataDailyActivity()" :csv-title="csv_title">
                          <vs-button class="gradient-btn">
                              <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                          </vs-button>
                        </vue-json-to-csv>
                          <vs-button
                          class="ml-1 gradient-btn"
                          target="_blank"
                          title="Download PDF"
                          @click="generatePDFDailyActivity()"
                          >
                          <feather-icon icon="FileTextIcon" class></feather-icon>
                          </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- day/week/month timesheet component -->
                <div class="w-full mt-5">
                  <div v-show="timesheet_type == 'day' ">
                  <daily-activity ref="dailyTimeActivity" :search="search" :office_id="office_id" :department_id="department_id" :current_date="day_current_date" ></daily-activity>
                  </div>
                  <div v-show="timesheet_type == 'week' ">
                    <weekly-activity ref="weeklyActivity" :search="search" :office_id="office_id" :department_id="department_id" :current_date="week_current_date"></weekly-activity>
                  </div>
                </div>
              </vx-card>
    </div>
</template>
<script>
import vSelect from "vue-select";
import { EventBus } from '@/mixins/mixin.js';
import Datepicker from "vuejs-datepicker";
import DailyActivity from "@/components/user-timesheet/activity/daily.vue";
import WeeklyActivity from "@/components/user-timesheet/activity/weekly.vue";
import VueJsonToCsv from "vue-json-to-csv";
import TimesheetDetail from "@/components/user-timesheet/timesheet-detail.vue";
export default {
    components:{
       vSelect,
       DailyActivity,
       WeeklyActivity,
       Datepicker,
       VueJsonToCsv,
       TimesheetDetail,
       EventBus
    },
    props:{
      search: {
        required: false,
        default: '',
        type: String
      },
      office_id: {
      required: false,
      default: 'all',
      type: String
    },
    department_id: {
      required: false,
      default: 'all',
      type: String
    },
    },
    data() {
        return {
            showCSVPDFButtons:false,
            main_tab: 0,
            sub_tab:0,
        //    search: null,
            all_offices: [],
         //   office_id: null,
            all_departments: [],
           // department_id: null,
            timesheet_type: 'day',
            format: "dd/MM/yyyy",
            disabledDates: {
                              from: new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate() + 1
                              ) // Disable all dates after specific date
                            },
            day_current_date: new Date(),
            week_current_date: new Date(),
        }
    },
     computed: {
      csv_title(){
          if (this.timesheet_type == 'day') {
            return 'DayData';
          }
          if (this.timesheet_type == 'week') {
            return 'WeekData';
          }
      }
    },
    watch:{
      timesheet_type(){
        this.showCSVPDFButtons = false;
      },
        office_id(){
            this.getDepartments();
        }
    },
    mounted(){
        this.getOffice();
            EventBus.$on('showButton', (data) => {
               this.showCSVPDFButtons = data;
          });
    },
    methods: {
        async getOffice() {
            this.$vs.loading({color: "primary"});
            let url = "office/getAll";
            this.all_offices = await this.axios
                .get(url)
                .then(response => {
                    this.$vs.loading.close();
                    let data = response.data.data;   
                    if (data && data.length) {
                        return data;
                    }      
                    return [];
                })
                .catch(e => {
                    this.showError(e);
                    return [];
                });
        },
        async getDepartments() {
            this.$vs.loading({ color: "primary"});
            let url = `dept/getAll?office_id=${this.office_id}`;
            this.all_departments = await this.axios
                .get(url)
                .then(response => {
                    this.$vs.loading.close();
                    let data = response.data.data;
                    if (data && data.length) {
                        return data;
                    }      
                    return [];
                })
                .catch(e => {
                    this.showError(e);
                    return [];
                });
        },
        generatePDFDailyActivity(){
          if (this.timesheet_type == 'day') {
            EventBus.$emit("dayDailyTimeAcitivityPDF");
          }
          if(this.timesheet_type == 'week'){
             EventBus.$emit("dayWeekTimeAcitivityPDF");
          }
        },
        getCsvDataDailyActivity(){
           if (this.timesheet_type == 'day') {
            return this.$refs.dailyTimeActivity ? this.$refs.dailyTimeActivity.csvData : [];
          }
          if (this.timesheet_type == 'week') {
            return this.$refs.weeklyActivity ? this.$refs.weeklyActivity.csvData : [];
          }
        }
    },
    destroyed() {
    EventBus.$off('showButton');
  },
}
</script>
<style>
.fc-today-button,
.fc-month-button,
.fc-agendaWeek-button,
.fc-agendaDay-button {
  display: none !important;
}
.application-action {
  float: left !important;
}

.time-box {
  background-color: lightgrey;
  width: 100px;
  border: 1px black;
  padding: 5px;
  margin: 2px;
  text-align: center;
  float: left;
}

.vs-table--tbody {
  z-index: 1 !important;
}

.vdp-datepicker {
  z-index: 2;
}

.vdp-datepicker__calendar {
  right: 0;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .datepicker-main {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    } */
.datepicker-main {
  display: flex;
  align-items: center;
  width: auto;
}
.datewrapper {
  display: flex;
}

.datewrapper label {
  float: right;
  text-align: right;
  line-height: 40px;
  padding-right: 10px;
  font-size: 14px !important;
  font-weight: bold;
}

.sidesheet .vs-sidebar {
  max-width: 450px !important;
  z-index: 99999 !important;
}
.total-hours {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  border-radius: 5px;
  margin-bottom: 10px;
}
.vs-table--search {
  margin: 0 !important;
}
.feather-download,
.feather-printer,
.feather-file-text {
  width: 16px;
  height: 16px;
}
.activity-table {
  max-height: 300px;
  overflow-x: auto;
}
.center-col {
  border-left: 1px solid #e7e7e7 !important;
  border-right: 1px solid #e7e7e7 !important;
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.fc-event,
.fc-event-dot {
  background-color: #3aad68;
}
.fc-event .fcc-content {
  padding-left: 3px;
}
.fc-unthemed td.fc-today {
  background: #3f57fe;
  color: #fff;
}
.fc-unthemed td.fc-past {
  background: #ff9000;
}
.fc-toolbar {
  text-align: right;
}
.hide {
  display: none;
}
.activity-table .header-table {
  justify-content: flex-end !important;
}
.status-table {
  margin-top: 58px;
}
</style>

<style lang="scss">
.sidesheet .vs-sidebar--background {
  z-index: 99999 !important;
}

.sidesheet .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.sidesheet .footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.delete-timesheet {
  margin: 16px 0px;
  padding: 0px 20px;
}

.sidesheet .vs-sidebar--items {
  height: 756px;
  overflow-y: scroll;
}
.vs-table .vs-table--thead .td-check{
  width: 1%;
}

</style>
